import { motion } from 'framer-motion';
import moment from 'moment';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

const Countdown = ({
  startData,
  startTime,
  endTime,
  status,
  iframe_type,
  iframe,
}: {
  startData: string;
  startTime: string;
  endTime: string;
  status: string;
  iframe_type?: string;
  iframe?: string;
}) => {
  const router = useRouter();
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
  });
  const { workshop_id } = router.query;

  const calculateTimeLeft = () => {
    if (!startData || !startTime) return { days: 0, hours: 0, minutes: 0 };

    const [hour, minute, second] = startTime.split(':').map(Number);
    const localDate = moment(startData).local();

    const eventDateTime = moment({
      year: localDate.year(),
      month: localDate.month(),
      date: localDate.date(),
      hour,
      minute,
      second,
    });

    const now = moment();

    if (!eventDateTime.isValid() || eventDateTime.isBefore(now)) {
      return { days: 0, hours: 0, minutes: 0 };
    }

    const diffMillis = eventDateTime.diff(now);
    const duration = moment.duration(diffMillis);

    return {
      days: Math.floor(duration.asDays()),
      hours: Math.floor(duration.asHours()) % 24,
      minutes: Math.floor(duration.asMinutes()) % 60,
    };
  };

  useEffect(() => {
    const update = () => {
      const updatedTime = calculateTimeLeft();
      setTimeLeft(updatedTime);

      const now = moment();
      const [endHour, endMinute, endSecond] = endTime.split(':').map(Number);

      const eventEndDateTime = moment({
        year: moment(startData).year(),
        month: moment(startData).month(),
        date: moment(startData).date(),
        hour: endHour,
        minute: endMinute,
        second: endSecond,
      });

      if (
        now.isBefore(eventEndDateTime) &&
        updatedTime.days === 0 &&
        updatedTime.hours === 0 &&
        updatedTime.minutes <= 0 &&
        status !== 'completed'
      ) {
        if (
          iframe_type === 'google_meet' &&
          iframe &&
          typeof window !== 'undefined'
        ) {
          router.push(iframe as string);
        } else {
          router.push(`/live/watch/${workshop_id}/?workshop_id=${workshop_id}`);
        }
      }
    };

    update();
    const interval = setInterval(update, 60000);
    return () => clearInterval(interval);
  }, [startData, startTime, endTime, router, iframe, iframe_type]);
  return (
    <div className='flex justify-center gap-1'>
      <CountdownUnit value={timeLeft.days} label='d' />
      <CountdownUnit value={timeLeft.hours} label='h' />
      <CountdownUnit value={timeLeft.minutes} label='m' />
    </div>
  );
};

const CountdownUnit = ({ value, label }: { value: number; label: string }) => {
  const displayValue = isNaN(value) ? '00' : value.toString().padStart(2, '0');

  return (
    <motion.div
      className='flex items-end bg-black border-[#3C3B3E] border rounded-[6px] md:rounded-xl py-1 px-3.5 text-primary'
      initial={{ scale: 1 }}
      animate={{ scale: [1, 1.05, 1] }}
      transition={{ duration: 0.5, repeat: 0, repeatType: 'reverse' }}
    >
      <span className='text-xs md:text-sm 2xl:text-base font-medium'>
        {displayValue}
      </span>
      <span className='text-xs md:text-sm ml-1 2xl:text-base font-medium'>
        {label}
      </span>
    </motion.div>
  );
};

export default Countdown;
